import { render, staticRenderFns } from "./Honorar.vue?vue&type=template&id=2ae04e98&"
import script from "./Honorar.vue?vue&type=script&lang=js&"
export * from "./Honorar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports